// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, STREAM, Weaver, WeaverHistory, enc;

  Weaver = require('./Weaver');

  GET = Weaver.GET;

  POST = Weaver.POST;

  STREAM = Weaver.STREAM;

  enc = encodeURIComponent;

  WeaverHistory = class WeaverHistory {
    constructor() {}

    static countHistory(params = {}, target) {
      var cm, ref;
      cm = Weaver.getCoreManager();
      if (params.branchUid == null) {
        params.branchUid = ((ref = cm.currentBranch) != null ? ref.id() : void 0) || cm.defaultBranch;
      }
      return POST("v2.projects", {
        method: "GET",
        path: `/branches/${enc(params.branchUid)}/count`
      }, target);
    }

    // getHistory accepted parameters (params)

    // params:
    //  - limit: limit the returned ammount of results
    //  - offset: for the pagination results
    //  - order: sort for response; could be ascending by default (not need to add) or descending mode
    //  - nodeIds: array with the node Ids to restrict the response
    //  - branchUid: restricts results for the branch uid
    //  - dateAfter: restricts results for dates after
    //  - dateBefore: restricts results for dates before
    //  - graphs: array with the graph or graphs to restrict the response
    //  - userIds: array with the user Ids to restrict the response
    //  - propertyIds: array with the attribute or relation Ids to restrict the response
    static async getHistory(params = {}, target) {
      var stream;
      stream = (await WeaverHistory.streamHistory(params, target));
      return new Promise(function(resolve, reject) {
        var json;
        json = '';
        stream.on('err', function(err) {
          return reject(err);
        });
        stream.on('data', function(d) {
          return json += d;
        });
        return stream.on('end', function() {
          return resolve(JSON.parse(json));
        });
      });
    }

    static async streamHistory(params, target) {
      var cm, ref, stream, updatePayload;
      cm = Weaver.getCoreManager();
      if (params.branchUid == null) {
        params.branchUid = ((ref = cm.currentBranch) != null ? ref.id() : void 0) || cm.defaultBranch;
      }
      stream = cm.createStream();
      updatePayload = {
        method: 'GET',
        path: `/branches/${enc(params.branchUid)}/history`
      };
      delete params.branchUid;
      params.stream = stream;
      updatePayload.body = params;
      await STREAM("v2.projects", updatePayload, target);
      return stream;
    }

  };

  module.exports = WeaverHistory;

}).call(this);
